import "../styles/llms.css";

function Placeholder() {
  // Keep LLM UI exploration independent from backend implementation details.
  return (
    <section className="feature-shell">
      <h2>LLMs Feature</h2>
      <p>Use this space to sketch prompts, completions, and embeddings views.</p>
    </section>
  );
}

export default Placeholder;
